var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var AddIcon = function (props) { return (React.createElement("svg", __assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_1987_6052)" },
        React.createElement("path", { d: "M6.99984 12.8333C10.2215 12.8333 12.8332 10.2216 12.8332 6.99996C12.8332 3.7783 10.2215 1.16663 6.99984 1.16663C3.77818 1.16663 1.1665 3.7783 1.1665 6.99996C1.1665 10.2216 3.77818 12.8333 6.99984 12.8333Z", stroke: "#443EFF", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M7 4.66663V9.33329", stroke: "#443EFF", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M4.6665 7H9.33317", stroke: "#443EFF", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_1987_6052" },
            React.createElement("rect", { width: "14", height: "14", fill: "white" }))))); };
export default AddIcon;
//# sourceMappingURL=AddIcon.js.map